export default "__VITE_ASSET__Cguvxeqm__"